module.exports = require("events");


//////////////////
// WEBPACK FOOTER
// external "events"
// module id = 21
// module chunks = 0 1